import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL || "";
export const api = axios.create({ baseURL: `${BASE}/api`, withCredentials: true });

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const cfg = error.config || {};
    const url = cfg.url || "";
    if (error.response?.status === 401 && !cfg._retry && !url.includes("/auth/login") && !url.includes("/auth/refresh")) {
      cfg._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(cfg);
      } catch (e) {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  }
);

export const imgUrl = (path) => (path ? `${BASE}/api/files/${path}` : "");

export function errMsg(e, fallback) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || "").filter(Boolean).join(" ");
  return fallback || e?.message || "Error";
}

export const waLink = (number, text) => `https://wa.me/${String(number || "").replace(/\D/g, "")}?text=${encodeURIComponent(text)}`;

export function fmtPhone(number) {
  const d = String(number || "").replace(/\D/g, "");
  const m = d.match(/^212(\d)(\d{2})(\d{3})(\d{3})$/);
  return m ? `+212 ${m[1]}${m[2]} ${m[3]} ${m[4]}` : d ? `+${d}` : "";
}

export const mapsUrl = (q) => `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;

export function scrollToId(id) {
  const el = document.getElementById(id);
  if (!el) return false;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -72, duration: 1.6 });
  else el.scrollIntoView({ behavior: "smooth" });
  return true;
}
